import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import didInsert from 'webapp/modifiers/did-insert';
import didUpdate from 'webapp/modifiers/did-update';
import willDestroy from 'webapp/modifiers/will-destroy';

interface Args {
	messages: string[];
	intervalTime: number;
}

export default class CommonTypewriterComponent extends Component<Args> {
	@tracked message = '';

	messageInterval: ReturnType<typeof setInterval> | null = null;
	typingCharTimeout: ReturnType<typeof setTimeout> | null = null;

	typewrite(message: string) {
		if (this.typingCharTimeout) clearTimeout(this.typingCharTimeout);
		const typeChar = (index: number) => {
			this.message += message.charAt(index);
			index++;
			if (index < message.length) {
				this.typingCharTimeout = setTimeout(typeChar, 50, index);
			}
		};
		this.typingCharTimeout = setTimeout(typeChar, 50, 0);
	}

	@action
	startTypewriter() {
		if (!this.messageInterval) {
			this.message = '';
			let messageCounter = 0;
			const writeMessage = () => this.typewrite(this.args.messages[messageCounter] + '...');
			writeMessage();
			this.messageInterval = setInterval(() => {
				if (
					document.visibilityState === 'visible' &&
					messageCounter < this.args.messages.length - 1
				) {
					messageCounter++;
					this.message = '';
					writeMessage();
				}
			}, this.args.intervalTime);
		}
	}

	@action
	stopTypewriter() {
		if (this.messageInterval) {
			clearInterval(this.messageInterval);
			this.messageInterval = null;
		}

		if (this.typingCharTimeout) {
			clearTimeout(this.typingCharTimeout);
			this.typingCharTimeout = null;
		}
	}

	@action
	restartTypewriter() {
		this.stopTypewriter();
		this.startTypewriter();
	}
	<template>
		<p
			class="typewriter-message"
			{{didInsert this.startTypewriter}}
			{{willDestroy this.stopTypewriter}}
			{{didUpdate this.restartTypewriter @messages @intervalTime}}
		>
			{{this.message}}
		</p>
	</template>
}
